import React, { FC } from "react";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTriangleExclamation } from '@fortawesome/free-solid-svg-icons';
import { BuildDetail } from "../../models/BuildDetails";
import { useLocale } from "../../contexts/localeContext";

interface LicenseBannerProps {
    buildInfo: BuildDetail;
    message: string;
    iconColor: string; // Color parameter
}

const LicenseBanner: FC<LicenseBannerProps> = ({ buildInfo, message: messageTranslationKey, iconColor }) => {
    const { translate } = useLocale();

    return <div className='p-3 border-2 border-solid my-2' style={{ borderColor: iconColor === 'red' ? 'red' : 'orange', backgroundColor: iconColor === 'red' ? '#FFEBEB' : '#FFF3E0' }}>
        <FontAwesomeIcon color={iconColor} icon={faTriangleExclamation} />

        <span className='pl-1 ml-px text-sm text-black'>
            {translate.byKeyFormatted(messageTranslationKey,
                [buildInfo?.licenseName, buildInfo?.licenseDate])}
        </span>
    </div>
}

export default LicenseBanner;